import axios from "axios";

async function checkInRange(lat, lng) {
	return new Promise(async (resolve, reject) => {
		try {
			let token = localStorage.getItem("token");
			let url =
				process.env.VUE_APP_API_URL +
				`/api/frontend/get-distance?latitude=${lat}&longitude=${lng}`;
			const config = {
				headers: {
					"Content-type": "application/json",
					Authorization: `Bearer ${token}`,
				},
			};
			let {data} = await axios.post(url, null, config);
			return resolve(data.status);
		} catch (error) {
			return reject(error);
		}
	});
}

function formatCurrency(number) {
	return new Intl.NumberFormat(process.env.VUE_APP_LOCALE, {
		style: "currency",
		currency: process.env.VUE_APP_CURRENCY,
	}).format(number);
}

function msToHMS(miliseconds, format = null) {
	var days, hours, minutes, seconds, total_hours, total_minutes, total_seconds;
	total_seconds = parseInt(Math.floor(miliseconds / 1000));
	total_minutes = parseInt(Math.floor(total_seconds / 60));
	total_hours = parseInt(Math.floor(total_minutes / 60));
	days = parseInt(Math.floor(total_hours / 24));
	seconds = parseInt(total_seconds % 60);
	minutes = parseInt(total_minutes % 60);
	hours = parseInt(total_hours % 24);
	switch(format) {
	  case 's':
		  return total_seconds;
	  case 'm':
		  return total_minutes;
	  case 'h':
		  return total_hours;
	  case 'd':
		  return days;
	  default:
		  return `${days}d ${hours}h ${minutes}m ${seconds}s`;
	}
}

export {checkInRange, formatCurrency, msToHMS};
